<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
  <div class="home-content">
    <div id="page-index" v-show="!searchShow">
      <van-nav-bar title="首页" @click-left="showPopup" fixed :z-index="1000">
        <img slot="left" src="../assets/image/icon_v2/class_icon@2x.png" class="title-icon" />
        <div slot="title">
          <van-search placeholder="输入你要搜索的古籍名称" background="rgba(143,94,63,1)" @focus="onFocus">
            <div slot="left-icon">
              <img src="../assets/image/icon_v2/search.png" class="search-icon" />
            </div>
          </van-search>
        </div>
        <div slot="right">
          <router-link to="contact_us">
            <img src="../assets/image/icon_v2/home_phone_icon@2x.png" class="title-icon" />
          </router-link>
        </div>
      </van-nav-bar>

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()">
        <van-grid :column-num="2" :gutter="10">
          <van-grid-item v-for="(book,item) in books" :key="item" @click="info(book.book_id)">
            <van-image :src="book.cover" width="82" height="101" />
            <div class="grid-item-title">{{book.name}}</div>
            <div class="grid-item-author">{{book.author}}</div>
          </van-grid-item>
        </van-grid>
      </van-list>

      <van-popup v-model="show" position="left" :style="{ height: '100%',width:'100%'}">
        <van-nav-bar @click-left="hidePopup" fixed :z-index="1000" class="menu-title-box">
          <img slot="left" src="../assets/image/icon_v2/return_black@2x.png" class="return_icon" />
          <div slot="title">
            <div
              class="menu-title"
              :class="titleActive == 1?'active':''"
              @click="menuClick(1,1)"
            >本土著述<span class="bor-bot" v-show="titleActive == 1"></span></div>
            <div
              class="menu-title"
              :class="titleActive != 1?'active':''"
              @click="menuClick(2,1)"
            >域外著述<span class="bor-bot" v-show="titleActive != 1"></span></div>
          </div>
        </van-nav-bar>
        <div class="menu-content">
          <div class="left-menu">
            <div
              class="itemize-level-1"
              :class="activeClass == index?'active':''"
              v-for="(category,index) in categories"
              :key="index"
              @click="menuClick(category.category_id,2,index)"
            >{{category.name}}</div>
          </div>
          <div class="right-menu">
            <div
              class="border-title"
              v-for="(category,index) in subItems"
              :key="index"
              @click="menuClick(category.category_id,3)"
            >
              <p class="itemize-level-2">{{category.name}}</p>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div id="page-search" v-show="searchShow">
      <van-search
        id="search-input"
        placeholder="输入你要搜索的古籍名称"
        v-model="key"
        show-action
        @search="onSearch"
        @cancel="onCancel"
        :clearable="false"
        @focus="clearShow"
        background="rgba(143,94,63,1)"
        autofocus
      >
        <img slot="left-icon" src="../assets/image/icon_v2/search.png" class="search-icon" />
        <img
          slot="right-icon"
          src="../assets/image/icon_v2/cancel_icon@2x.png"
          v-show="clear"
          @click="clearSearchInput"
          class="search-icon"
        />
      </van-search>
      <div class="key-content-box" v-if="recent_searches.length>0">
        <div class="title-box">
          <p class="font-c-9 font-title">最近搜索</p>
          <img src="../assets/image/delete_icon@2x.png" @click="clearRecentSearch" />
        </div>
        <div class="key-box">
          <p
            class="key"
            v-for="(word,index) in recent_searches.slice(0,5)"
            :key="index"
            @click="toSearch(word)"
          >{{word}}</p>
        </div>
      </div>
      <div class="key-content-box">
        <div class="title-box">
          <p class="font-c-9 font-title">热门搜索</p>
        </div>
        <div class="key-box">
          <p
            class="key"
            v-for="(keyword,index) in hotKeies"
            :key="index"
            @click="toSearch(keyword.word)"
          >{{keyword.word}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search, Grid, GridItem, Image, Popup, List, NavBar } from "vant";

export default {
  data() {
    return {
      books: [],
      subItems: null,
      categories: null,
      localCategories: null,
      outsideCategories: null,
      show: false,
      loading: false,
      finished: false,
      currentPage: 0,
      categoryId: 1,
      level: 1,
      searchShow: false,
      key: null,
      hotKeies: [],
      recent_searches: [],
      clear: false,
      activeClass: 0,
      titleActive: 1
    };
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        var page = this.currentPage + 1;

        this.bookList(this.categoryId, this.level, page);

        // 加载状态结束
        this.loading = false;
      }, 500);
    },
    bookList(categoryId = 1, level = 1, page = 1, pageSize = 10) {
      var that = this;
      var params = {
        category_id: categoryId,
        level: level,
        channel: 'h5',
        page: page,
        page_size: pageSize
      };
      this.$api.get("/books", { params }).then(function(res) {
        var data = res.data.data;
        that.currentPage = data.current_page;
        if (data.current_page == 1) {
          that.books = res.data.data.books;
        } else {
          that.books = that.books.concat(data.books);
        }
        if (that.currentPage == data.total_pages) {
          that.finished = true;
        }
      });
    },
    categoryList(type = 1) {
      var that = this;
      var params = {
        type: type
      };
      this.$api.get("/book/menus", { params }).then(function(res) {
        if (type == 1) {
          that.localCategories = res.data.data;
        } else {
          that.outsideCategories = res.data.data;
        }
      });
    },
    menuClick(categoryId, level = 1, index = 0) {
      if (level == 1) {
        this.categories =
          categoryId == 1 ? this.localCategories : this.outsideCategories;
        this.titleActive = categoryId;
        this.activeClass = 0;
        this.subItems = this.categories[0].subItems;
      } else if (level == 2) {
        this.subItems = this.categories[index].subItems;
        this.activeClass = index;
      } else {
        this.categoryId = categoryId;
        this.level = level;
        this.bookList(categoryId, this.level);
        this.hidePopup();
      }
    },
    clearShow() {
      this.clear = true;
    },
    clearSearchInput() {
      this.key = null;
      this.clear = false;
    },
    onFocus() {
      this.searchShow = true;
      var that = this;
      var params = {
        num: 7
      };
      this.$api.get("/book/hot_word", { params }).then(function(res) {
        that.hotKeies = res.data.data;
      });
    },
    onCancel() {
      this.key = null;
      this.searchShow = false;
    },
    onSearch() {
      if (this.key) {
        this.$store.commit("setRecentWord", this.key);
        this.searchShow = false;
        if (this.$store.state.recent_word !== "") {
          this.recent_searches = this.$store.state.recent_word
            .split(",")
            .reverse();
        }
        var key = this.key;
        this.key = "";
        this.$router.push({ path: "/search/" + key });
      }
    },
    toSearch(keyword) {
      this.key = keyword;
      this.onSearch();
    },
    clearRecentSearch() {
      this.$store.commit("clearRecentWord");
      this.recent_searches = [];
    },
    showPopup() {
      var level = 1;
      if (this.categoryId > 2) {
        level = 2;
      }
      this.menuClick(this.categoryId, level, this.activeClass);
      this.show = true;
    },
    hidePopup() {
      this.show = false;
    },
    info(bookId) {
      this.$router.push({ path: "/info/" + bookId });
    },
    shareConfig(){
      let url = window.location.href.split('#')[0]
      let obj = {
        title:'千年医典数据库',
        desc:'中外学者、古籍专家历时四十余年，先后对千余年来留存于日本和世界各国的中医文献进行系统整理而成',
        link: url,
        imgUrl:'http://shenhuanglive.oss-cn-shanghai.aliyuncs.com/image/test_img/5d77551d2963f.jpg'
      }
      this.$wxApi.getJSSDK(url,obj)
    }
  },
  created() {
    this.categoryList();
    this.categoryList(2);
    if (this.$store.state.recent_word !== "") {
      this.recent_searches = this.$store.state.recent_word.split(",").reverse();
    }
    this.shareConfig();

    const hashLocation = this.$route.path
		const url = "https://m.kanguji.com"+hashLocation
		this.$matomo.setCustomUrl(url);
  },
  components: {
    [NavBar.name]: NavBar,
    [Search.name]: Search,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Popup.name]: Popup,
    [List.name]: List
  }
};
</script>


// WEBPACK FOOTER //
// src/components/index.vue